// registry/FieldRegistry.js
import { getFieldComponent } from "./FieldRegistry";

export default function DataTypeFactory({ type, value, onChange, mode = "edit", config, options, ...props }) {
  const Component = getFieldComponent(type);
  
  // Pass additional props that might be needed by specific field types
  const fieldProps = {
    value,
    onChange,
    mode,
    config,
    options,
    type, // Pass the type for components that need it (like DateTimeField)
    ...props
  };
  
  return <Component {...fieldProps} />;
}